import { formatCurrency } from '../../../lib/helpers/formatters';

const SummaryTotalRow = ({ total = 0, toEmit = 0 }) => (
  <tr className="summary-tr">
    <td>-</td>
    <td className="txt-table-right">{formatCurrency(total)}</td>
    <td className="txt-table-right">{formatCurrency(toEmit)}</td>
  </tr>
);

export default SummaryTotalRow;
